import React, { useEffect, useState } from 'react';
import './Dashboard.css';

function Dashboard() {
    const [catopt, setCatopt] = useState('none');
    const [catval, setCatval] = useState('Category');
    const [loaderdis, setLoaderdis] = useState('none');
    const [poptxt, setPoptxt] = useState('');
    const [poperr, setPoperr] = useState('');
    const [features, setFeatures] = useState([
        { name: "Material", description: "" },
        { name: "Size (inches)", description: "" },
        { name: "Capacity", description: "" },
        { name: "Care Instruction", description: "" }
    ]);
    const [images, setImages] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);

    const [formdata, setFormdata] = useState({
        name: "",
        category: "",
        images: [],
        discountprice: 0,
        description: "",
        features: {
            name: '',
            description: ''
        }
    });

    const addFeatures = () => {
        setFeatures(prev => [...prev, { name: "", description: "" }]);
    }

    const featNameChange = (e, ind) => {
        const val = e.target.value;
        const newarr = [...features];
        newarr[ind].name = val;
        setFeatures(newarr);
    }

    const featDescChange = (e, ind) => {
        const val = e.target.value;
        const newarr = [...features];
        newarr[ind].description = val;
        setFeatures(newarr);
    }

    const featDelFunc = (ind) => {
        const newarr = [...features];
        if (newarr.length > 1) {
            newarr.splice(ind, 1);
            setFeatures(newarr);
        }
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0]; // only one file at a time
        if (!file) return;

        // add to existing list
        setImages(prev => [...prev, file]);
        setPreviewUrls(prev => [...prev, URL.createObjectURL(file)]);

        // reset input so same file can be reselected if needed
        e.target.value = "";
    };

    useEffect(() => {
        setFormdata(prev => ({ ...prev, category: catval }));
    }, [catval]);

    useEffect(() => {
        setFormdata(prev => ({ ...prev, features: features }));
    }, [features]);

    const validateFormData = () => {
        const { name, category, discountprice, description } = formdata;

        if (!name || !discountprice || !category || !description || features.length === 0 || images.length === 0) {
            setPoperr("Please fill all required fields.");
            setTimeout(() => setPoperr(''), 3000);
            return false;
        }

        const invalidFeature = features.some(item => !item.name || !item.description);

        if (invalidFeature) {
            setPoperr("Please complete all feature fields.");
            setTimeout(() => setPoperr(''), 3000);
            return false;
        }

        return true;
    };

    const uploadFunc = async () => {
        const isvalid = validateFormData();
        if (!isvalid) return;

        setLoaderdis('flex');

        try {
            // STEP 1: Upload images
            const imgFormData = new FormData();
            images.forEach((image) => {
                imgFormData.append('images', image);
            });

            const imgRes = await fetch("https://pentadeco.in/api/uploadimg", {
                method: "POST",
                body: imgFormData
            });

            const imgData = await imgRes.json();

            if (!imgRes.ok || !imgData.success) {
                throw new Error("Image upload failed");
            }

            // Suppose the API returns uploaded image URLs in imgData.urls (adjust if different)
            const uploadedImageUrls = imgData.urls || [];

            // STEP 2: Upload product data with uploaded image URLs
            const productPayload = {
                name: formdata.name,
                category: formdata.category,
                discountprice: formdata.discountprice,
                description: formdata.description,
                features: features,
                images: uploadedImageUrls
            };

            const prodRes = await fetch("https://pentadeco.in/api/uploadproduct", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(productPayload)
            });

            const prodData = await prodRes.json();

            setLoaderdis('none');
            if (prodRes.ok && prodData.success) {
                setPoptxt("Product uploaded successfully");
                setTimeout(() => setPoptxt(''), 3000);
                console.log(prodData);
            } else {
                throw new Error("Product upload failed");
            }

        } catch (err) {
            setLoaderdis('none');
            setPoperr(err.message || 'Error occurred while uploading the data');
            setTimeout(() => setPoperr(''), 3000);
            console.error(err);
        }
    };

    return (
        <div className='main-dashboard'>
            <div className="container upload-form-wrap mt-4 mb-5">
                <h2 className="fs-4 body-font-bold border-bottom pb-3">Upload Products</h2>
                <div className="form-wrap mt-3">

                    <p className="mb-2 body-font-semibold">Product name</p>
                    <input type="text" className='form-control' placeholder='Product name' value={formdata.name} onChange={(e) => setFormdata(x => ({ ...x, name: e.target.value }))} />

                    <div className="mt-4">
                        <p className="mb-2 body-font-bold fs-5">Price</p>
                        <input type="number" className='form-control' value={formdata.discountprice} onChange={(e) => setFormdata(x => ({ ...x, discountprice: e.target.value }))} />
                    </div>

                    <p className="mb-2 body-font-semibold mt-4">Product Description</p>
                    <textarea rows={3} className='form-control' placeholder='Product Description' value={formdata.description} onChange={(e) => setFormdata(x => ({ ...x, description: e.target.value }))}></textarea>

                    <div className="category-wrap mt-4">
                        <p className="mb-2 body-font-bold fs-5">Product category</p>
                        <div className="d-flex justify-content-between align-items-center border rounded p-2 cursor-pointer" onClick={() => setCatopt(catopt === 'none' ? 'block' : 'none')}>
                            <input type="text" className='form-control border-0' value={catval} onChange={(e) => setCatval(e.target.value)} />
                            <i className="fas fa-sort-down text-muted fs-5 mb-1 me-2"></i>
                        </div>
                        <div className="category-options-wrap" style={{ display: catopt }}>
                            {[
                                "capsule mug",
                                "inside colour mug",
                                "Magic Mug",
                                "White Mug",
                                "Bag Tag",
                                "Mouse Pad",
                                "Coasters",
                                "Coke Bottle",
                                "Sipper Water Bottle (600ml)",
                                "Sipper Water Bottle (750ml)",
                                "Sports Water Bottle",
                                "Set of 2 Cups",
                                "Frosted Glass Jar",
                                "Money Bank",
                                "Wall Decor",
                                "tote bag",
                                "copper bottle"
                            ].map(cat => (
                                <p key={cat.toLocaleLowerCase()} className="mb-0 bg-light p-2 text-capitalize cursor-pointer" onClick={(e) => { setCatopt('none'); setCatval(cat.toLocaleLowerCase()); }}>{cat}</p>
                            ))}
                        </div>
                    </div>

                    <div className="features-wrap mt-4">
                        <p className="mb-2 body-font-bold fs-5">Features</p>
                        {features.map((feat, ind) => (
                            <div key={ind} className="row mb-3 align-items-center">
                                <div className="col-4 pe-0">
                                    <input type="text" className="form-control" placeholder='Feature' value={feat.name} onChange={(e) => featNameChange(e, ind)} />
                                </div>
                                <div className="col-7 pe-2">
                                    <input type="text" className="form-control" placeholder='Description' value={feat.description} onChange={(e) => featDescChange(e, ind)} />
                                </div>
                                <div className="col-1 text-center ps-0" onClick={() => featDelFunc(ind)}>
                                    <i className="fas fa-trash-alt text-muted"></i>
                                </div>
                            </div>
                        ))}
                        <button className="btn btn-outline-dark" onClick={addFeatures}>Add More</button>
                    </div>

                    <div className="mt-4">
                        <p className="mb-2 body-font-bold fs-5">Product Images</p>
                        <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
                        <div className="d-flex flex-wrap gap-2 mt-3">
                            {previewUrls.map((url, index) => (
                                <img
                                    key={index}
                                    src={url}
                                    alt={`preview-${index}`}
                                    className="rounded"
                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                />
                            ))}
                        </div>
                    </div>

                    <button className="btn btn-dark mt-4" onClick={uploadFunc}>Upload product</button>
                </div>
            </div>

            <div className="full-overlay" style={{ display: loaderdis }}>
                <div className="loader-wrap rounded-brand p-4">
                    <div className="loader-roundedr"></div>
                </div>
            </div>

            <div className="position-fixed w-100 p-2 pb-3 bottom-0" style={{ display: poptxt === '' ? 'none' : 'block' }}>
                <p className="mb-0 p-2 bg-success-subtle text-success border border-success rounded">{poptxt}</p>
            </div>
            <div className="position-fixed w-100 p-2 pb-3 bottom-0" style={{ display: poperr === '' ? 'none' : 'block' }}>
                <p className="mb-0 p-2 bg-danger-subtle text-danger border border-danger rounded">{poperr}</p>
            </div>
        </div>
    )
}

export default Dashboard;
